import Vue from 'vue'
import Router from 'vue-router'
import Task from '@/components/Task.vue'
import Signup from '@/components/Signup'
import Signin from '@/components/Signin'
import firebase from 'firebase'


Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: 'signin'
    },
    {
      path:'/',
      name:'task',
      component: Task,
      meta: { requiresAuth: true}
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    }
  ]
})

router.beforeEach((to,from,next)=>{
  // 遷移しようとしている画面が、認証必要かを確認している
  // requiresAuthのメタデータを持っていて、trueなら認証必要、falseなら不要
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let currentUser = firebase.auth().currentUser
  if(requiresAuth){ //認証が必要な場合
    if(!currentUser){ //ログインユーザがいない場合は
      next({
        path: '/signin',
        query: {redirect: to.fullPath}
      })
    }else {
      next()
    }
  }else {
    next()
  }
})

export default router
